import Login from "./auth/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-tagsinput/react-tagsinput.css";
import "react-quill/dist/quill.snow.css";
import UserManagement from "./components/userManagement";
import { BrowserRouter as Router, Navigate, useRoutes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Header from "./components/Header";
import AddEditUserManagement from "./pages/AddEditUserManagement";
import { connect } from "react-redux";
import AdminProfile from "./pages/AdminProfile";
import ItemListing from "./pages/ItemListing";
import "./css/style.css";
import RunningAuctions from "./pages/RunningAuctions";
import PastAuction from "./pages/PastAuction";
import EditListItem from "./components/EditListItem";
import Category from "./pages/Category";
import SideNav from "./components/SideNav";
import "@fortawesome/fontawesome-free/css/all.min.css";
import BidManagement from "./pages/BidManagement";
import CMS from "./pages/CMSPages/CMS";
import { ProSidebarProvider } from "react-pro-sidebar";
import AdminSideBar from "./components/AdminSideBar";
import FAQ from "./pages/CMSPages/FAQ";
import Policy from "./pages/CMSPages/Policy";
import Terms from "./pages/CMSPages/Terms";
import HowItWorks from "./pages/CMSPages/HowItWorks";
import HomePages from "./pages/CMSPages/HomePages";
import PointsSystem from "./pages/LevelSystem/PointsSystem";
import WhatIsInsertBid from "./pages/CMSPages/WhatIsInsertBid";
import ContactUs from "./pages/CMSPages/ContactUs";
import SellItem from "./pages/CMSPages/SellItem";
import SalesHistory from "./pages/SalesHistory";
import { Spinner } from "react-bootstrap";
import Staff from "./pages/StaffManage";
import AddEditStaff from "./pages/StaffManage/addEditStaff";
import DisputesList from "./pages/Disputes";
import AboutUsContent from "./pages/CMSPages/AboutUsContent";
import FlagCommentsList from "./pages/FlagCommentsList";
import ChangePassword from "./components/ChangePassword";
import PhotoGuide from "./pages/CMSPages/PhotoGuide";
import HeaderContent from "./pages/CMSPages/HeaderContent";
import BlogSpotlightContent from "./pages/CMSPages/BlogSpotlightContent";
import NotifyUsers from "./pages/NotifyUsers";
import StoreManager from "./pages/StoreManager";
import AwardsSystem from "./pages/AwardsSysten";
import EmailUsers from "./pages/EmailUsers";
import ShipmentManager from "./pages/ShipmentManager";
import ManageConversations from "./pages/ManageConversations";
import CollectiblesShipping from "./pages/CMSPages/CollectiblesShipping";
import Blog from "./pages/CMSPages/Blog.tsx";
import EventManagement from "./pages/EventManagement";
import AdminLayout from "./components/AdminLayout.js";
import { Routes } from "react-router-dom";
import QuickAuctionPage from "./components/QuickAuctionPage.js";
import ReputationContent from "./pages/CMSPages/ReputationContent.js";

import UserDataOverview from "./pages//Data/UserDataOverview";
import AuctionDataOverview from "./pages/Data/AuctionDataOverview";
import BidDataOverview from "./pages/Data/BidDataOverview";
import AutobidDataOverview from "./pages/Data/AutobidDataOverview";
import AuctionDataDetail from "./pages/Data/AuctionDataDetail.js";
import AffiliateManager from "./pages/AffiliateManager.js";
import HallOfFameManager from "./pages/HallOfFameManager.js";
import PlayLaterAdmin from "./pages/PlayLaterAdmin.js";
import SpotlightManager from "./pages/CMSPages/SpotlightManager.tsx";
import CollectionsManager from "./pages/CMSPages/CollectionsManager.tsx";
import RoomsManager from "./pages/CMSPages/RoomsManager.tsx";
import PostsReportsManager from "./pages/CMSPages/PostsReportsManager.tsx";
import UserReportsManager from "./pages/UserReportsManager.tsx";
import CreateAdminPost from "./pages/CMSPages/CreateAdminPost.tsx";

function App({ user, isLoading, resetToken }) {
  const AuthRoutes = () =>
    useRoutes([
      { path: "/", element: <Login /> },
      { path: "/login", element: <Login /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ]);

  const AfterLoginCustomerRoutes = () =>
    useRoutes([
      { path: "/", element: <UserManagement /> },
      // { path: "/users", element: <UserManagement /> },
      { path: "/profile", element: <AdminProfile /> },
      { path: "/user", element: <UserManagement /> },
      { path: "/addUser", element: <AddEditUserManagement /> },
      { path: "/editUser/:id", element: <AddEditUserManagement /> },
      { path: "/item-listing", element: <ItemListing /> },
      { path: "/sales-history", element: <SalesHistory /> },
      { path: "/user-reports", element: <UserReportsManager /> },
      // { path: "/auction-management", element: <RunningAuctions /> },
      // { path: "/past-auction", element: <PastAuction /> },
      { path: "/bid-management", element: <BidManagement /> },
      { path: "/store-management", element: <StoreManager /> },
      // { path: "/cms-pages", element: <CMS /> },
      { path: "/cms-pages/header", element: <HeaderContent /> },
      { path: "/cms-pages/blog-spotlight", element: <SpotlightManager /> },
      { path: "/cms-pages/homepages", element: <HomePages /> },
      { path: "/ib-shipping", element: <ShipmentManager /> },
      { path: "/conversations", element: <ManageConversations /> },
      { path: "/events", element: <EventManagement /> },
      { path: "/play-later", element: <PlayLaterAdmin /> },
      { path: "/dev", element: <QuickAuctionPage /> },
      { path: "/cms-pages/faq", element: <FAQ /> },
      { path: "/cms-pages/blogs", element: <Blog /> },
      { path: "/cms-pages/hall-of-fame", element: <HallOfFameManager /> },
      { path: "/cms-pages/privacy-policy", element: <Policy /> },
      { path: "/cms-pages/rep-system", element: <ReputationContent /> },
      { path: "/cms-pages/terms", element: <Terms /> },
      { path: "/cms-pages/what-is-insert-bids", element: <WhatIsInsertBid /> },
      { path: "/cms-pages/how-it-works", element: <HowItWorks /> },
      { path: "/cms-pages/contact-us", element: <ContactUs /> },
      { path: "/cms-pages/about-us", element: <AboutUsContent /> },
      { path: "/notify-users", element: <NotifyUsers /> },
      { path: "/email-users", element: <EmailUsers /> },
      { path: "/cms-pages/sell-an-item", element: <SellItem /> },
      { path: "/cms-pages/photo-guide", element: <PhotoGuide /> },
      {
        path: "/cms-pages/collectibles-shipping",
        element: <CollectiblesShipping />,
      },
      { path: "/edit-list/:id", element: <EditListItem /> },
      { path: "/category", element: <Category /> },
      { path: "/badge", element: <PointsSystem /> },
      { path: "/awards", element: <AwardsSystem /> },
      { path: "/staff", element: <Staff /> },
      { path: "/staff/:id", element: <AddEditStaff /> },
      { path: "/staff/add", element: <AddEditStaff /> },
      { path: "/disputes", element: <DisputesList /> },
      { path: "/flag-comments", element: <FlagCommentsList /> },
      { path: "/change-password", element: <ChangePassword /> },
      { path: "/usersdata", element: <UserDataOverview /> },
      { path: "/auctionsdata", element: <AuctionDataOverview /> },
      { path: "/auctionsdata/:id", element: <AuctionDataDetail /> },
      { path: "/biddata", element: <BidDataOverview /> },
      { path: "/autobiddata", element: <AutobidDataOverview /> },
      { path: "/affiliate-management", element: <AffiliateManager /> },
      { path: "/community/rooms", element: <RoomsManager /> },
      { path: "/community/posts-reports", element: <PostsReportsManager /> },
      { path: "/cms-pages/posts", element: <CreateAdminPost /> },
      { path: "/collections", element: <CollectionsManager /> },

      { path: "*", element: <Navigate to="/" replace /> },
    ]);

  const SideBarDashBoard = () => {
    return (
      <ProSidebarProvider>
        <AdminSideBar />
      </ProSidebarProvider>
    );
  };

  return (
    <Router>
      <ToastContainer limit={1} />
      {user ? (
        <ProSidebarProvider>
          <Header />

          <AdminLayout>
            <div className="home-page w-100">
              {isLoading && (
                <Spinner
                  animation="border"
                  variant="warning"
                  className="spinner"
                />
              )}

              <AfterLoginCustomerRoutes />
            </div>
          </AdminLayout>
        </ProSidebarProvider>
      ) : (
        <AuthRoutes />
      )}
    </Router>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state?.auth?.user,
    resetToken: state?.auth?.resetToken,
    isLoading: state.loading.isLoading,
  };
};

export default connect(mapStateToProps)(App);
